import { Divider, SxProps, useMediaQuery, useTheme } from "@mui/material";
import { PageHeader, PageHeaderProps, useApp } from "daymap-react";

const PageHeaderPositioned: React.FC<PageHeaderProps> = (props) => {
    const md = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const theme = useTheme();
    const { studentAppBarEl } = useApp();

    let sx:SxProps = {}

    if (md)
        sx = {
            backgroundColor: 'transparent',
            color: 'primary.main',
            boxShadow: 'none'
        }
    else 
        sx = {
            paddingTop: !studentAppBarEl ? 'env(safe-area-inset-top)' : undefined,
            top: studentAppBarEl ? `${studentAppBarEl?.getBoundingClientRect().height}px` : '0px',
            zIndex: studentAppBarEl ? theme.zIndex.appBar - 1 : theme.zIndex.appBar,
        }

    return <>
        <PageHeader {...props} position={md ? "relative" : "fixed"} sx={sx}/>
        {md && <Divider />}
    </>
}

export default PageHeaderPositioned;